import { CommonModule } from '@angular/common';
import { Component,inject,Inject,Input } from '@angular/core';
import {
MatLegacyDialogConfig as MatDialogConfig,
MatLegacyDialogModule,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BehaviorSubject,Observable,of } from 'rxjs';
import { map,shareReplay,switchMap,tap } from 'rxjs/operators';
import { SharepointObjectEntity } from '../../../../../dave-data-module/entities/sharepoint-object.entity';
import { DaveLoadingModule } from '../../../../../dave-loading/dave-loading.module';
import { AppButtonModule } from '../../../../../dave-utils-module/app-button-module/app-button.module';
import {
IDetailListTemplateData,IDetailListTemplateDataProperty
} from '../../../../../dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import {
CustomPropertyType
} from '../../../../../dave-utils-module/dave-shared-components-module/components/detail-views/profile-template/profile-template.component';
import {
DaveSharedComponentsModule
} from '../../../../../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { FileSizePipe } from '../../../../../dave-utils-module/dave-shared-components-module/pipes/filesize.pipe';
import { SharepointDataService } from '../sharepoint-data.service';
import { isNotNullOrUndefined } from '../../../../../helper/helper';

export type SharepointObjectPreviewDialogComponentDialogData = {
    id: string;
}

export type SharepointObjectPreviewDialogComponentDialogReturnData = undefined;

@Component({
    selector: 'app-sharepoint-object-preview-dialog',
    standalone: true,
    imports: [CommonModule, AppButtonModule, FontAwesomeModule, MatLegacyDialogModule, DaveLoadingModule, DaveSharedComponentsModule, MatLegacyTooltipModule],
    templateUrl: './sharepoint-object-preview-dialog.component.html',
    styleUrls: ['./sharepoint-object-preview-dialog.component.scss'],
    providers: [FileSizePipe],
})
export class SharepointObjectPreviewDialogComponent {
    public static DefaultConfig: MatDialogConfig = {
        maxWidth: '100vw',
        hasBackdrop: false,
        panelClass: 'custom-dialog-class-for-overlay-on-right-side',
    };
    sharepointData = inject(SharepointDataService);
    fileSizePipe = inject(FileSizePipe);
    private _id$ = new BehaviorSubject<string>(null);
    protected loading$ = new BehaviorSubject<boolean>(false);
    protected sharepointObject$: Observable<SharepointObjectEntity | null> = this._id$.pipe(
        tap(() => this.loading$.next(true)),
        switchMap((id) => (id ? this.sharepointData.get$({ Id: id }) : of(null))),
        tap(() => this.loading$.next(false)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected sharepointObjectDetails$: Observable<IDetailListTemplateData> = this.sharepointObject$.pipe(
        switchMap((obj) =>
            this.sharepointData.getFolderAndParentsById(obj.Id, false).pipe(
                map((path) => {
                    if (!obj) {
                        return null;
                    }
                    const Properties: IDetailListTemplateDataProperty[] = [
                        {
                            key: 'Größe',
                            value: isNotNullOrUndefined(obj.Size) ? `${this.fileSizePipe.transform(obj.Size)}` : null,
                        },
                        {
                            key: 'Hochgeladen am',
                            value: obj.CreatedAt,
                            options: {
                                type: CustomPropertyType.Datum,
                            },
                        },
                        {
                            key: 'Aktualisiert am',
                            value: obj.UpdatedAt,
                            options: {
                                type: CustomPropertyType.Datum,
                            },
                        },
                        {
                            key: 'Pfad',
                            value: path.map((f) => f.Name).join('/') + '/' + obj.Name,
                            options: {
                                type: CustomPropertyType.Link,
                                linkPayload: {
                                    href: obj.Url,
                                },
                            },
                        },
                    ];
                    return {
                        Headline: obj.Name,
                        Properties,
                    };
                }),
            ),
        ),
    );
    protected thumbnailIsLoaded = false;

    @Input() set id(v: string) {
        if (v !== this._id$.value) {
            this.thumbnailIsLoaded = false;
            this._id$.next(v);
        }
    }
    get id(): string {
        return this._id$.value;
    }
    constructor(@Inject(MAT_DIALOG_DATA) dialogData: SharepointObjectPreviewDialogComponentDialogData) {
        this.id = dialogData.id;
    }

    protected readonly Object = Object;
}
